export default __webpack_public_path__ + "static/media/vidimg.c448675c.png";